var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-main',{staticClass:"layout-main"},[_c('TabsBar'),_c('keep-alive',{attrs:{"max":_vm.maxTabs,"include":_vm.cachedRoutes}},[_c('router-view',{key:_vm.key,ref:"main",staticClass:"app-main"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }